export default __webpack_public_path__ + "static/media/project_2.c41a37f0.jpg";